export class MenuConfigOptions {
    basePath?: string;
}
